/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * 
 * @export
 * @interface PaxCheckGetPaxSessionResponse
 */
export interface PaxCheckGetPaxSessionResponse {
    /**
     * 
     * @type {PaxCheckPaxSession}
     * @memberof PaxCheckGetPaxSessionResponse
     */
    data?: PaxCheckPaxSession;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckGetPaxSessionResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckGetPaxSessionResponse interface.
 */
export function instanceOfPaxCheckGetPaxSessionResponse(value: object): value is PaxCheckGetPaxSessionResponse {
    return true;
}

export function PaxCheckGetPaxSessionResponseFromJSON(json: any): PaxCheckGetPaxSessionResponse {
    return PaxCheckGetPaxSessionResponseFromJSONTyped(json, false);
}

export function PaxCheckGetPaxSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckGetPaxSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckPaxSessionFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckGetPaxSessionResponseToJSON(json: any): PaxCheckGetPaxSessionResponse {
    return PaxCheckGetPaxSessionResponseToJSONTyped(json, false);
}

export function PaxCheckGetPaxSessionResponseToJSONTyped(value?: PaxCheckGetPaxSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckPaxSessionToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

